import React from 'react'
import { colors, borderRadius } from '../../styles/tokens'
import { styles } from '../../styles/newQuotation.styles'

/**
 * Seção de imagens para um tipo de bloco (hotel, carro, tour)
 * 
 * Responsabilidade: Renderizar inputs de imagem para múltiplos itens do mesmo tipo
 * 
 * Props:
 *   - imageCount: número de imagens por item (padrão: 3)
 */
export default function ImageBlocksSection({
    title,
    icon: Icon,
    items,
    images,
    onImageChange,
    emoji,
    imageCount = 3
}) {
    const inputStyle = {
        ...styles.input,
        fontSize: '0.8125rem',
        padding: '0.625rem'
    }

    // Gera array [1, 2, 3] ou [1] dependendo do imageCount
    const imageNumbers = Array.from({ length: imageCount }, (_, i) => i + 1)

    // Define grid columns baseado no número de imagens
    const gridColumns = imageCount === 1 ? '1fr' : `repeat(${imageCount}, 1fr)`

    return (
        <div style={styles.sectionBox}>
            <h4 style={styles.sectionTitle}>
                <Icon size={18} />
                {title}
            </h4>

            {items.map((itemName, index) => {
                const imgs = images?.[itemName] || {}
                const existing = imgs.existing || {}

                return (
                    <div
                        key={itemName}
                        style={{
                            marginBottom: index < items.length - 1 ? '1.5rem' : 0,
                            paddingBottom: index < items.length - 1 ? '1.5rem' : 0,
                            borderBottom: index < items.length - 1 ? `1px solid ${colors.border}` : 'none'
                        }}
                    >
                        <p style={{
                            fontSize: '0.875rem',
                            fontWeight: 600,
                            color: colors.text.primary,
                            margin: '0 0 0.75rem 0'
                        }}>
                            {emoji} {itemName}
                        </p>

                        <div style={{ display: 'grid', gridTemplateColumns: gridColumns, gap: '0.75rem' }}>
                            {imageNumbers.map((num) => {
                                const imgKey = `img${num}`
                                const existingImg = existing[imgKey]

                                return (
                                    <div key={num}>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '0.75rem',
                                            color: colors.text.muted,
                                            marginBottom: '0.25rem'
                                        }}>
                                            {imageCount === 1 ? 'Foto' : `Foto ${num}`} {existingImg ? '✓' : ''}
                                        </label>

                                        {existingImg ? (
                                            <>
                                                <div style={{
                                                    borderRadius: borderRadius.sm,
                                                    overflow: 'hidden',
                                                    height: '60px',
                                                    opacity: 0.7
                                                }}>
                                                    <img
                                                        src={existingImg}
                                                        alt=""
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                    />
                                                </div>
                                                <p style={{
                                                    fontSize: '0.625rem',
                                                    color: colors.accent,
                                                    margin: '0.25rem 0 0 0'
                                                }}>
                                                    ✓ Cadastrada
                                                </p>
                                            </>
                                        ) : (
                                            <>
                                                <input
                                                    type="url"
                                                    value={imgs?.[imgKey] || ''}
                                                    onChange={(e) => onImageChange(itemName, imgKey, e.target.value)}
                                                    placeholder="https://..."
                                                    style={inputStyle}
                                                />
                                                {imgs?.[imgKey] && (
                                                    <div style={{
                                                        marginTop: '0.375rem',
                                                        borderRadius: borderRadius.sm,
                                                        overflow: 'hidden',
                                                        height: '50px'
                                                    }}>
                                                        <img
                                                            src={imgs[imgKey]}
                                                            alt=""
                                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                            onError={(e) => { e.target.style.display = 'none' }}
                                                        />
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
